<template>
  <div class="viewcontent" v-if="translations.buttons && translations.program">
    <form class="row mx-3" @submit.prevent="processProgram()">
      <Alert type="warning" :list="errors.program"/>

      <div class="col-sm-6 col-xs-12">
        <div v-if="languageSelected">
          <label
            for="title"
            class="form-label w-100 my-3"
            v-for="(title, titleindex) in checkTitleLanguage(
              languageSelected.toUpperCase()
            )"
            :key="titleindex"
            ><span class="key"> [{{ languageSelected.toUpperCase() }}] </span>
            {{ translations.program.form_title }}

            <span class="text-danger">*</span>
            <input
              type="text"
              id="title"
              name="title"
              class="form-control"
              v-model="title.text"
              required
            />
          </label>

          <label
            for="description"
            class="form-label w-100 my-3"
            v-for="(description, descriptionindex) in checkDescriptionLanguage(
              languageSelected.toUpperCase()
            )"
            :key="descriptionindex"
            ><span class="key"> [{{ languageSelected.toUpperCase() }}] </span>
            {{ translations.program.form_description }}
            <span class="text-danger">*</span>
            <textarea
              rows="5"
              class="form-control"
              id="description"
              name="description"
              v-model="description.text"
              required
            >
            </textarea>
          </label>
        </div>
      </div>

      <div class="col-sm-6 col-xs-12">
        <label for="pictures" class="form-label w-100 my-3"
          >{{ translations.program.form_pictures }} (800x600px)
          <span class="text-danger">*</span>
          <input
            type="file"
            accept=".jpg,.jpeg"
            id="pictures"
            name="pictures"
            class="form-control"
            @change="onPictureChange"
            required
          />
        </label>

        <div class="col-12 p-4">
          <div class="col-12" v-if="preview">
            <img
              class="img-fluid img-thumbnail"
              :src="preview"
              :alt="program.title"
            />
          </div>
          <div
            class="col-12 p-4"
            v-else-if="typeof program.picture == 'string'"
          >
            <div class="col-12">
              <img
                class="img-fluid img-thumbnail"
                :src="files + program.picture"
                :alt="program.title"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 pt-2" v-if="translations.buttons">
        <button class="btn btn-danger mx-2" type="button" @click="cancel()">
          {{ translations.buttons.btn_exit }}
        </button>
        <input
          class="btn btn-primary mx-2"
          type="submit"
          :disabled="usertype !== 2"
          :value="translations.buttons.btn_edit"
        />
      </div>
    </form>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import Alert from '@/components/atoms/Alert.vue'
  export default {
    name: 'ToolProgramAdd',
    components: {
      Alert,
    },
    data() {
      return {
        input: {
          title: [],
          description: [],
        },
        preview: false,
      }
    },
    computed: {
      ...mapState([
        'languageSelected',
        'translations',
        'files',
        'errors',
        'programID',
        'program',
        'usertype',
      ]),
    },
    methods: {
      ...mapActions([
        'resetError',
        'editProgram',
        'getProgram',
        'changeToolSelected',
      ]),
      processProgram() {
        this.program.title = JSON.stringify(this.input.title)
        this.program.description = JSON.stringify(this.input.description)
        if (this.usertype == 2) {
          this.editProgram(this.program)
        }
      },
      checkTitleLanguage(language) {
        return this.input.title.filter((item) => item.key == language)
      },
      checkDescriptionLanguage(language) {
        return this.input.description.filter((item) => item.key == language)
      },
      cancel() {
        this.changeToolSelected(null)
      },
      onPictureChange(e) {
        let file = e.target.files
        this.program.pictures = file

        if (e.target.files.length !== 0) {
          this.preview = URL.createObjectURL(file[0])
        }
      },
      generateInputs() {
        if (this.languageSelected) {
          let found = this.input.title.some(
            (el) => el.key === this.languageSelected.toUpperCase()
          )
          if (!found) {
            this.input.title.push({
              key: this.languageSelected.toUpperCase(),
              text: '',
            })
            this.input.description.push({
              key: this.languageSelected.toUpperCase(),
              text: '',
            })
          }
        } else {
          this.input.title = []
          this.input.description = []
        }
      },
      async setInputs() {
        if (this.program.title && this.input.title.length <= 0) {
          this.input = {
            title: this.program.title,
            description: this.program.description,
          }

          if (this.input.title && this.input.title.length <= 0) {
            await this.generateInputs()
          }
        }
      },
    },
    async created() {
      await this.getProgram(this.programID)
      await this.setInputs()
      this.generateInputs()
    },
    beforeUnmount() {
      this.resetError()
    },
  }
</script>

<style scoped>
  .key {
    text-transform: uppercase;
    font-weight: bold;
  }
</style>
